import { UserX } from 'lucide-react';
import { Trans, useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import { useState } from 'react';
import logoNagy from '../../assets/logos/logonagy.png';

function AppHeader() {
  const { user, deleteAccount } = useAuth();
  const { t } = useTranslation();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const deleteItems = t('app.header.deleteItems', { returnObjects: true });

  const handleDeleteAccount = async () => {
    setShowDeleteModal(false);
    await deleteAccount();
  };

  return (
    <header className="bg-gradient-to-br from-indigo-100 via-sky-100 to-emerald-100 shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-between">
        <div className="flex items-center space-x-3">
            <img src={logoNagy} alt="Told Fel Logo" className="h-20 sm:h-20" />
          <div>
            <h1 className="text-lg sm:text-xl font-bold text-gray-800">{t('common.brandName')}</h1>
            <p className="text-xs text-gray-500">{user?.email}</p>
          </div>
        </div>
        

      </div>

      {/* Delete Account Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
            <div className="flex items-start space-x-3 mb-4">
              <div className="flex-shrink-0">
                <UserX className="h-6 w-6 text-red-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {t('app.header.deleteTitle')}
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  <Trans i18nKey="app.header.deleteDescription" components={{ strong: <strong /> }} />
                </p>
                <p className="text-sm text-gray-600 mb-4">
                  {t('app.header.deleteDataHeading')}
                </p>
                <ul className="text-sm text-gray-600 list-disc list-inside mb-4 space-y-1">
                  {deleteItems.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
            
            <div className="flex space-x-3 justify-end">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
              >
                {t('app.header.cancel')}
              </button>
              <button
                onClick={handleDeleteAccount}
                className="px-4 py-2 text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors"
              >
                {t('app.header.confirmDelete')}
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default AppHeader;